import { useAppSelector } from '@/redux/hooks';
import { selectAllLanguages, selectRawCustomerList, selectAvailPlatform } from '@/redux/selectors/constantsSelectors';
import { availLicenses } from '../constants';

const AvailEnumMap = ({ type, value }: { type: string; value: string | number }) => {
  const allLanguages = useAppSelector(selectAllLanguages);
  const allCustomers = useAppSelector(selectRawCustomerList);
  const allPlatforms = useAppSelector(selectAvailPlatform);

  if (type === 'territory' && typeof value === 'string') {
    const regionName = new Intl.DisplayNames(['en'], { type: 'region' });
    return regionName.of(value.toLocaleUpperCase());
  }
  if (type === 'language' && typeof value === 'string') {
    return allLanguages.find((Language) => Language.code.replace('-', '_') === value.replace('-', '_'))?.label || value;
  }
  if (type === 'platform') {
    return allPlatforms[value] || value;
  }
  if (type === 'customer') {
    return allCustomers[value] || value;
  }
  if (type === 'license') {
    return availLicenses.find((license) => license[0] === value)?.[1] || value;
  }
  return value;
};

export default AvailEnumMap;
